import React from "react";
import Sidebar from "../Sidebar";
import TermsAndConditionsComponent from "../termsAndConditionsComponent/termsAndConditionsComponent";

const TermsAndConditionsPage = () => {
  return (
    <Sidebar>
      <TermsAndConditionsComponent />
    </Sidebar>
  );
};

export default TermsAndConditionsPage;
